import { NavLink } from "react-router-dom";
import { LogOut, Mail, MapPinned, Bus, Wrench, Truck, BarChart3 } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { ChangePassword } from "./ChangePassword";

const LINKS = [["/admin/trafico", "Pasajes", Bus], ["/admin/cargas", "Cargas y turismo", Truck], ["/admin/flota", "Flota", Wrench], ["/admin/mensajes", "Mensajes", Mail], ["/admin/agencias", "Agencias", MapPinned], ["/admin/ventas", "Ventas", BarChart3]];
const linksFor = (role) => (role === "admin" ? LINKS : role === "taller" ? LINKS.filter(([to]) => to === "/admin/flota") : LINKS.slice(0, 1));

export const AdminNav = ({ title }) => {
  const { user, logout } = useAuth();
  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div>
        <p data-testid="admin-nav-identity" className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--forest)]">{user?.role === "boleteria" ? `Boletería · ${user.office}` : user?.role === "taller" ? "Taller" : "Panel privado"} · {user?.email}</p>
        <h1 className="mt-3 font-display text-4xl md:text-5xl">{title}</h1>
        <div className="mt-5 flex flex-wrap gap-2">
          {linksFor(user?.role).map(([to, l, I]) => (
            <NavLink key={to} to={to} data-testid={`admin-nav-${to.split("/").pop()}`} className={({ isActive }) => `inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-bold ${isActive ? "bg-[var(--forest)] text-white" : "bg-white"}`}>
              <I className="h-4 w-4" /> {l}
            </NavLink>
          ))}
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        <ChangePassword />
        <button onClick={logout} data-testid="admin-logout-button" className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white px-5 py-2.5 text-sm font-semibold"><LogOut className="h-4 w-4" /> Salir</button>
      </div>
    </div>
  );
};
